import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Theme } from "tinymce";
import {
  EnableNewProductProposal,
  GetStorePublic,
  SendFormStore,
  StoreCategories
} from "../interfaces/store.interface";
import { ViaCep } from "../interfaces/via-cep.interface";
import { Store } from "../models/user.model";
import { AuthenticationService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class ApiServiceStore {
  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };
  private optionsHeaderNoAuth = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25"
    })
  };
  private optionsHeaderFile = {
    headers: new HttpHeaders({
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  getStore() {
    return this.http.get<Store>(`/virtual-store/store`, this.optionsHeader);
  }

  createStore(data: { name: string }) {
    return this.http.post<void>(`/virtual-store/store`, data, this.optionsHeader);
  }

  checkNameStore(data: { name: string }) {
    return this.http.post<void>(`/virtual-store/site-name`, data, this.optionsHeader);
  }

  updateLogo(uuid: string, data: FormData) {
    return this.http.patch<{ Location: string; Key: string }>(
      `/virtual-store/${uuid}/icon`,
      data,
      this.optionsHeaderFile
    );
  }

  updateCustomStore(uuid: string, data: Theme, group_uuid?: string) {
    const params = group_uuid ? new HttpParams({ fromObject: { group_uuid } }) : null;
    return this.http.patch<void>(`/virtual-store/${uuid}/theme`, data, {
      ...this.optionsHeader,
      params
    });
  }

  updateNameStore(uuid: string, data: { name: string }) {
    return this.http.put<Store>(`/virtual-store/${uuid}`, data, this.optionsHeader);
  }

  getStorePublic(siteName: string) {
    // em desenvolvimento descomente essa linha abaixo:
    // return of(GET_STORE_PUBLIC);

    return this.http.get<GetStorePublic>(`/virtual-store-public/store/${siteName}`, this.optionsHeaderNoAuth);
  }

  dealStorePublic(siteName: string, data: SendFormStore) {
    data.description = "loja";
    return this.http.post<void>(`/virtual-store-public/${siteName}/deal`, data, this.optionsHeaderNoAuth);
  }

  getByType(type: string, slug: string) {
    return this.http.get<StoreCategories[]>(
      `/virtual-store-public/store/products/${slug}?type=${type}`,
      this.optionsHeaderNoAuth
    );
  }

  getCep(cep: string) {
    return this.http.get<ViaCep>(`/via-cep/${cep}`);
  }

  enableNewProductProposalPermission(slug: string, document: string, idProduct: string) {
    return this.http.get<any>(
      `/virtual-store-public/validation/request-client/${slug}/${document}/${idProduct}`,
      this.optionsHeader
    );
  }
}
